// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/financeiro/hooks/useRelatorios.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { relatoriosService } from '../services/relatoriosService';
import type { FluxoCaixaCenariosParams } from '../types';

export const useAgingPagar = (dataBase?: string) =>
  useQuery({
    queryKey: ['aging-pagar', dataBase],
    queryFn: () => relatoriosService.agingPagar(dataBase),
  });

export const useAgingReceber = (dataBase?: string) =>
  useQuery({
    queryKey: ['aging-receber', dataBase],
    queryFn: () => relatoriosService.agingReceber(dataBase),
  });

export const useInadimplencia = (
  tipo: 'receber' | 'pagar' = 'receber',
  diasMinimos = 1,
  dataBase?: string,
) =>
  useQuery({
    queryKey: ['inadimplencia', tipo, diasMinimos, dataBase],
    queryFn: () => relatoriosService.inadimplencia(tipo, diasMinimos, dataBase),
  });

export const useFluxoCaixaProjecao = (
  dtInicio?: string,
  dtFim?: string,
  agrupamento: 'dia' | 'semana' | 'mes' = 'dia',
) =>
  useQuery({
    queryKey: ['fluxo-caixa-projecao', dtInicio, dtFim, agrupamento],
    queryFn: () => relatoriosService.fluxoCaixa(dtInicio, dtFim, agrupamento),
    enabled: !!(dtInicio && dtFim),
  });

export const useFluxoCaixaCenarios = (params: FluxoCaixaCenariosParams) =>
  useQuery({
    queryKey: ['fluxo-caixa-cenarios', params],
    queryFn: () => relatoriosService.fluxoCaixaCenarios(params),
    enabled: !!(params.dtInicio && params.dtFim),
    staleTime: 5 * 60_000,
  });
